import { vuetify } from '@whispli/ui/plugins/vuetify'

/** @deprecated Vue 2 compatibility only. Remove after migration to vuetify 3 */
export const useVuetify = () => vuetify?.framework
